import React, { CSSProperties, useMemo } from 'react';

import { TBlock } from '@wp-block-builder/package';

import { TColumnsSectionBlockProps } from '../types';

import { getBlockWidth, getPaddingAfter, getPaddingBefore } from './cssProperties';

type Props = {
  blockProps: TColumnsSectionBlockProps;
  index: number;
  renderChildBlock: (block: TBlock | null, index: number) => JSX.Element;
};
export default function TableCell({ index, renderChildBlock, blockProps }: Props) {
  const style = useMemo<CSSProperties>(
    () => ({
      boxSizing: 'content-box',
      verticalAlign: blockProps.contentAlignment,
      textAlign: blockProps.blocks[index] ? 'left' : 'center',
      width: getBlockWidth(index, blockProps),
      paddingLeft: getPaddingBefore(index, blockProps),
      paddingRight: getPaddingAfter(index, blockProps),
    }),
    [index, blockProps]
  );

  return <td style={style}>{renderChildBlock(blockProps.blocks[index], index)}</td>;
}
